var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "mr-1 mb-3 right",
          attrs: { variant: "primary" },
          on: {
            click: function ($event) {
              _vm.isModalOpen = true
            },
          },
        },
        [_vm._v("\n        bezahl.de\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "cost-unit-payment-request-modal",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            size: "xl",
            title: "Zahlungsaufforderungen",
          },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
            show: _vm.loadPaymentRequestData,
          },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [_c("csp-loading-indicator")],
                1
              )
            : _c("b-row", [
                _vm.customerExists
                  ? _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("csp-payment-request-recipient", {
                          attrs: {
                            files: _vm.paymentRequestData.files.data,
                            "payment-request-data":
                              _vm.paymentRequestData.customerPaymentRequests
                                .data.attributes,
                            recipient: "customer",
                            "record-id": _vm.recordId,
                          },
                          on: {
                            "payment-request-sent": function ($event) {
                              _vm.loadPaymentRequestData
                              _vm.$emit("payment-request-sent")
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.lawyerExists
                  ? _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("csp-payment-request-recipient", {
                          attrs: {
                            files: _vm.paymentRequestData.files.data,
                            "payment-request-data":
                              _vm.paymentRequestData.lawyerPaymentRequests.data
                                .attributes,
                            recipient: "lawyer",
                            "record-id": _vm.recordId,
                          },
                          on: {
                            "payment-request-sent": function ($event) {
                              _vm.loadPaymentRequestData
                              _vm.$emit("payment-request-sent")
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.insuranceExists
                  ? _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("csp-payment-request-recipient", {
                          attrs: {
                            files: _vm.paymentRequestData.files.data,
                            "payment-request-data":
                              _vm.paymentRequestData.insurancePaymentRequests
                                .data.attributes,
                            recipient: "insurance",
                            "record-id": _vm.recordId,
                          },
                          on: {
                            "payment-request-sent": function ($event) {
                              _vm.loadPaymentRequestData
                              _vm.$emit("payment-request-sent")
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }